import { sendSnapQuote } from '@ui/features/quote-builder/state/endpoints/send-snap-quote';
import type { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import type { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

function sendQuoteFulfilled(state: WritableQuoteBuilderStateType) {
  state.dialog = null;
}

export function createSendQuoteReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(sendSnapQuote.matchFulfilled, sendQuoteFulfilled);
}
